import { t } from "i18next";
import emptyFieldValidate from "../shared/empty.validate";

export type TErrors = {
  message: string | undefined;
  contractAddress: string | undefined;
};

const NFTCollectorsValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    message: undefined,
    contractAddress: undefined,
  };

  errors.message = emptyFieldValidate(
    FormValues.message,
    t("core:common:message")
  );

  errors.contractAddress = emptyFieldValidate(
    FormValues.contractAddress,
    t("core:common:contract")
  );

  return errors;
};

export default NFTCollectorsValidate;
